import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { Api } from '$api';
import { batchActions } from '$store';
import { toastActions } from '$store/toast';
import { notesActions, notesSelector } from '$store/notes/index';
import {
  LoadNoteAction,
  DeleteNoteAction,
  NoteModel,
  UpdateNoteNameAction,
  UpdateNoteNoteAction,
} from '$store/notes/interface';

function* loadNoteWorker(action: LoadNoteAction) {
  try {
    const data = yield call(Api.get, `/notes/id${action.payload}`);
    if (data?.note) yield put(notesActions.setNote([data.note]));
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* loadNotesWorker() {
  try {
    const data = yield call(Api.get, '/notes');

    if (data?.notes) {
      const notesArray: Array<NoteModel> = Object.values(data.notes);

      if (notesArray.length > 0) {
        yield put(notesActions.setNote(notesArray));
      }
    }
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* updateNoteNameWorker(action: UpdateNoteNameAction) {
  yield put(toastActions.setToastLoading());

  const { userId, name } = action.payload;
  const { notes } = yield select(notesSelector);

  const foundNote = notes.find((item) => item.userId === userId);
  try {
    const data = yield call(Api.post, '/notes/add', {
      userId,
      note: foundNote?.note || '',
      name,
    });

    if (data?.note) {
      yield put(
        batchActions(notesActions.setNote([data.note]), notesActions.clearNote()),
      );
      yield put(toastActions.setToastSuccess());
    }
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* updateNoteNoteWorker(action: UpdateNoteNoteAction) {
  yield put(toastActions.setToastLoading());

  const { userId, note } = action.payload;
  const { notes } = yield select(notesSelector);

  const foundNote = notes.find((item) => item.userId === userId);
  try {
    const data = yield call(Api.post, '/notes/add', {
      userId,
      name: foundNote?.name || '',
      note,
    });

    if (data?.note) {
      yield put(
        batchActions(notesActions.setNote([data.note]), notesActions.clearNote()),
      );
      yield put(toastActions.setToastSuccess());
    }
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

// API поддерживает удаление, но, в кейсе не используется, добавил для будущего
function* deleteNoteWorker(action: DeleteNoteAction) {
  try {
    yield call(Api.post, '/notes/delete', { id: action.payload });
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

export function* notesSaga() {
  yield all([
    takeLatest(notesActions.loadNotes, loadNotesWorker),
    takeLatest(notesActions.loadNote, loadNoteWorker),
    takeLatest(notesActions.deleteNote, deleteNoteWorker),
    takeLatest(notesActions.updateNoteName, updateNoteNameWorker),
    takeLatest(notesActions.updateNoteNote, updateNoteNoteWorker),
  ]);
}
